import {
  CreateMultisigRequest,
  type CreateMyNativeAidRequest,
  FindAllNativeAidsRequest
} from '@/api/origin-agent-svc'
import { agentAIDService, agentMultisigService } from '@/utils/apis'

export const saveIdentifierToAgent = async (
  payload: CreateMyNativeAidRequest
) => {
  return await agentAIDService.saveMyNativeAid({
    createMyNativeAidRequest: payload
  })
}

export const saveMultisigToAgent = async (payload: CreateMultisigRequest) => {
  return await agentMultisigService.createMultisig({
    createMultisigRequest: payload
  })
}

export const findAllNativeAidsFromAgent = async (
  payload: FindAllNativeAidsRequest
) => {
  return await agentAIDService.findAllNativeAids(payload)
}
